// extracted by mini-css-extract-plugin
export default {"buttonsActions":"ButtonsTablePreconfig_buttonsActions__ZftvH","buttonIcon":"ButtonsTablePreconfig_buttonIcon__jE8Dn","actionIcon":"ButtonsTablePreconfig_actionIcon__u5fTX"};